import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const PayGradeDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Pay Grade"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Pay Grade">
                {getFieldDecorator('payGrade', {
                 initialValue: data.payGrade,
                  rules: [{ required: true, message: 'Please input the Pay Grade!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default PayGradeDialogForm;
